<template>
  <div class="feedback-box" @click="openMagicEditor">
    <div class="feedback-btn">
          {{ 'Try out AI Inpainting Alpha' | trans }} <i class="far fa-arrow-right"></i>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import { EventBus } from '../../events/event.bus';
import { OPEN_FEEDBACK_MODAL } from '../../events/app.events';
import { satGlobals } from '../../../../../../sat/helper/sat-globals';

export default {
  name: "MagicEditor",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openMagicEditor() {
      let locale = satGlobals.getLocale();
      window.open('/' + locale + '/ai-magic-editor');
    }
  },
  computed: {}
};
</script>
<style lang="scss">
.feedback-box {
  .feedback-btn {
    display: flex;
    padding: 7px 10px;
    align-items: center;
    width: max-content;
    gap: 10px;
    border-radius: 4px;
    border: 1px solid #595959;
    background: #333;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
